import { apiClient } from "./apiClient";
import { IEvaluationsResponse, IUpdateEvaluatorBody } from "../features/evaluations/Interfaces/IEvaluationInterface";

export async function getUserEvaluation(): Promise<IEvaluationsResponse> {
  const { data } = await apiClient.get<IEvaluationsResponse>("/evaluations/my-evaluation");
  return data;
}

export async function createEvaluationInvites(
  evaluationId: string,
  workColleagueId: string,
  socialColleagueId: string
): Promise<{ success: boolean }> {
  const body = { evaluationId, workColleagueId, socialColleagueId };
  const { data } = await apiClient.post<{ success: boolean }>("/evaluations/invites", body);
  return data;
}

export async function updateEvaluator(
  evaluationId: string,
  updateEvaluatorBody: IUpdateEvaluatorBody
): Promise<{ success: boolean }> {
  const body = updateEvaluatorBody;
  const { data } = await apiClient.put<{ success: boolean }>(`/evaluations/${evaluationId}/evaluators`, body);
  return data;
}

export async function startManagerEvaluation(
  evaluationId: string
): Promise<{ evaluatorId: string }> {
  const { data } = await apiClient.post<{ evaluatorId: string }>(
    `/evaluations/${evaluationId}/start-manager-evaluation`
  );
  return data;
}

export async function completeOverdueEvaluationAsHr(
  evaluationId: string,
  comment: string
): Promise<{ message: string }> {
  const { data } = await apiClient.post<{ message: string }>(
    `/evaluations/${evaluationId}/hr-completion`,
    { comment }
  );
  return data;
}
